// ABOUTME: Stores daily outfit suggestions and skip history
// ABOUTME: Caches today's suggestions to avoid regeneration on every page load

import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import type { WardrobeItem } from './wardrobeStore'

export interface SuggestedOutfit {
  items: WardrobeItem[]
  score: number
  description: string
}

interface SuggestionState {
  todaysSuggestions: SuggestedOutfit[] | null
  lastGeneratedDate: string | null
  skipHistory: Array<{ date: string; itemIds: string[] }>
}

interface SuggestionActions {
  setSuggestions: (suggestions: SuggestedOutfit[], date: string) => void
  recordSkip: (date: string, itemIds: string[]) => void
  clearAll: () => void
}

type SuggestionStore = SuggestionState & SuggestionActions

const initialState: SuggestionState = {
  todaysSuggestions: null,
  lastGeneratedDate: null,
  skipHistory: [],
}

export const useSuggestionStore = create<SuggestionStore>()(
  persist(
    (set) => ({
      ...initialState,

      setSuggestions: (suggestions, date) => {
        set({
          todaysSuggestions: suggestions,
          lastGeneratedDate: date,
        })
      },

      recordSkip: (date, itemIds) => {
        set((state) => ({
          skipHistory: [...state.skipHistory.slice(-30), { date, itemIds }],
        }))
      },

      clearAll: () => {
        set(initialState)
      },
    }),
    {
      name: 'gentleman-suggestion-store',
      partialize: (state) => ({
        todaysSuggestions: state.todaysSuggestions,
        lastGeneratedDate: state.lastGeneratedDate,
        skipHistory: state.skipHistory,
      }),
    }
  )
)
